import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ServiceLevelDemoService } from '../../design/demo-services/serviceLevel-demo.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceLevelBoardService {

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private demoService: ServiceLevelDemoService) { }

  getServiceLevelBoardData(boardLocation: string, view: string): Observable<any> {

    var url = `${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/callboard/boardData?view=${view}&location=${boardLocation}`;

    const loader = this.route.params.pipe(
      switchMap(bl => 
        (environment.demo ? this.demoService.get(view) : this.http.get(url))
          .pipe(
            map((b: any) => b),
            catchError(error => of({
              isLoading: false, 
              isLoaded: false,
              isError: true,
              errorMessage: error.error instanceof ErrorEvent ? `an error occurred: ${error.error.message}` : `backend error: ${error.status} - ${error.message}`,
              data: {}
            }))
          )
      ),
      map((d: any) => {

        var boardStatusFunc = (): number => {
          if(environment.demo)
            return 0;
          var startTime = new Date(d.LastUpdated);
          var endTime = new Date();
          var difference = endTime.getTime() - startTime.getTime(); 
          return Math.round(difference / 60000);
        };

        const ret = d.isError === true ? d : {

          skillsets: [] = d.Items,
          LastUpdated: environment.demo ? new Date().toLocaleString() : d.LastUpdated,

          minutesFromLastUpdate: boardStatusFunc(),

          isNotFound: d.Items.length === 0,

          isLoading: false,
          isLoaded: true,
          isError: false,
          errorMessage: ''
        };
        return ret;
      })
    );
    return loader;
  }
}
